import React from 'react';
import { formatCodeAmount } from '../../utils/analytics';

const TopBilledStatesBody = ({ states = [] }) => {
  if (states.length === 0) {
    return <span className="top-billed-states__empty">No billed states</span>;
  }

  return (
    <div className="top-billed-states">
      <div className="top-billed-states__rows">
        {states.map((state) => (
          <div key={state.stateInitials} className="top-billed-states__row">
            <span className="top-billed-states__name">{state.name}</span>
            <span className="top-billed-states__amount">{formatCodeAmount(state.totalAmount)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopBilledStatesBody;
